import { render, staticRenderFns } from "./OrderAdd.vue?vue&type=template&id=1ef56521&"
import script from "./OrderAdd.vue?vue&type=script&lang=ts&"
export * from "./OrderAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports